import { boundApiRequest } from '@/restapi/restapi.base.js';


const doRequest = boundApiRequest('/api/favorite/');


export async function change(resp) {
    const { result } = await doRequest('product/change', resp);
    return result;
}
